
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'CurrencyInput',
  props: {
    modelValue: {
      type: Number,
      required: true
    },
    label: {
      type: String,
      default: undefined
    },
    showRequired: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      isActive: false
    }
  },
  computed: {
    displayValue: {
      get: function(): string {
        if (this.isActive)
          return this.modelValue.toString()

        return '$ ' + this.modelValue.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,')
      },
      set: function(modifiedValue: string): void {
        let newValue = parseFloat(modifiedValue.replace(/[^\d.]/g, ''))
        if (isNaN(newValue))
          newValue = 0

        this.$emit('update:modelValue', newValue)
      }
    }
  }
})
